import {AllgKapGesAngaben, KorperschaftAngaben, OrtDesSitzes} from '@nachdigal';
import {FormBaseComponent, MappedStammdaten, StammdatenService} from '@utils-lib';
import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
    selector: 'common-ui-allgemeine-kapital-angaben',
    templateUrl: './allgemeine-kapital-angaben.component.html'
})
export class AllgemeineKapitalAngabenComponent extends FormBaseComponent<AllgKapGesAngaben | KorperschaftAngaben> implements OnInit {

    @Input()
    stammdaten: MappedStammdaten;

    @Input()
    isKapGes = false;

    @Input()
    metadata: Record<string, unknown>;

    @Input()
    pageTitle = '';

    constructor(private readonly formBuilder: FormBuilder,
                private readonly stammdatenService: StammdatenService,
                protected readonly messageService: DatevMessageService) {
        super(messageService);
    }

    public get ortDesSitzes(): OrtDesSitzes {
        if (this.isKapGes) {
            return (this.data as AllgKapGesAngaben).ortDesSitzes;
        } else {
            return null;
        }
    }

    public set ortDesSitzes(ort: OrtDesSitzes) {
        if (this.isKapGes) {
            (this.data as AllgKapGesAngaben).ortDesSitzes = ort;
        }
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({});
        if (this.data.inlandsadresse === undefined
            && this.data.auslandsadresse === undefined
            && this.data.kommunikationsmittel === undefined
            && !this.metadata?.touched) {
            this.stammdatenService.assignStammdatenIfDeterministic(this.getStammdatenMappingRules(), this.data);
        }
    }

    protected getStammdatenMappingRules(): Map<string, unknown> {
        return new Map<string, unknown | Array<unknown>>([
            ['juristischePerson.firmenname', this.stammdaten?.unternehmen?.firmenname],
            ['inlandsadresse', this.stammdaten?.unternehmen?.inlandsadressen],
            ['auslandsadresse', this.stammdaten?.unternehmen?.auslandsadressen],
            ['postfachadresse', this.stammdaten?.unternehmen?.postfachadressen],
            ['kommunikationsmittel.telefonnummern[0]', this.stammdaten?.unternehmen?.kommunikation?.telefonnummern],
            ['kommunikationsmittel.internet', this.stammdaten?.unternehmen?.kommunikation?.internetadressen],
            ['ortDesSitzes.ortDesSitzes', this.stammdaten?.unternehmen?.ortDesSitzes]
        ]);
    }
}
